import api from './client';

// Returns { total, remaining, sold, availableForSale }.
//
// Rejects with a 503 whenever Stripe is unreachable or the server is missing
// its credentials. Callers are expected to degrade rather than retry -- the
// drop page hides the counter and keeps its buy button, which is a plain link
// to buy.stripe.com and does not depend on this.
const getStock = async () => {
  const res = await api.get('/merch/stock')
  return res.data;
};

const merch = { getStock }
export default merch;
